import React from "react";

interface CustomSwitchProps {
  checked: boolean;
  onChange: (event: any) => void;
}
const CustomSwitch: React.FC<CustomSwitchProps> = ({ checked, onChange, ...props }) => {
  return (
    <label className="switch relative inline-block w-[3.0625rem] h-[1.625rem]">
      <input
        {...props}
        checked={checked}
        onChange={onChange}
        type="checkbox"
        className="toggle-input opacity-0 w-0 h-0"
      />
      <span className="slider absolute hover:cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full"></span>
    </label>
  );
};

export default CustomSwitch;
